import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GenericDeleteModal } from 'src/js/component/generic-delete-modal';

import { PresetViewModel } from './preset-models';
import { deletePreset } from './preset-store';

interface Props {
  itemsToDelete: PresetViewModel[];
  onSuccessDelete?: (deletedPresets: PresetViewModel[]) => void;
  onCancel?: VoidFunction;
}

export const PresetDeleteModal: React.FunctionComponent<Props> = ({ itemsToDelete, onSuccessDelete, onCancel }) => {
  const { t } = useTranslation();

  const [savedItemsToDelete] = useState(itemsToDelete); // NKE-3757 freeze the list because the parent may reset its selected state if api calls refresh the list

  const handleDelete = (): Promise<any[]> => {
    return Promise.all(savedItemsToDelete.map((item) => deletePreset(item, t)));
  };

  const formatPresetNames = (presets: PresetViewModel[]): string => {
    if (!presets.length) {
      return '';
    }

    // Display up to 9 names
    const displayLimit = 9;
    const displayedPresets = presets.slice(0, displayLimit);
    const displayedNames = displayedPresets.map((preset) => {
      const name = preset.name;
      return name.endsWith('.cfg') ? name.slice(0, -4) : name;
    });

    // If there are more than 9, add a "+ X more" suffix
    if (presets.length > displayLimit) {
      const remainingCount = presets.length - displayLimit;
      const lastPart = t('presets.modal.delete.listOfPresetsEnding', { count: remainingCount });
      return `${displayedNames.join(', ')}${lastPart}`;
    }
    return displayedNames.join(', ');
  };

  const listOfPresetNames = formatPresetNames(savedItemsToDelete);
  const body = (
    <>
      <span className="bodyTextBold">{listOfPresetNames}</span>
      <br />
      <br />
      {t('general.cannotUndo')}
    </>
  );

  return (
    <GenericDeleteModal
      title={t('presets.modal.delete.title', { count: savedItemsToDelete.length })}
      body={body}
      itemsToDelete={savedItemsToDelete}
      onDelete={handleDelete}
      onSuccess={onSuccessDelete}
      onCancel={onCancel}
    />
  );
};
